import React, { useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import * as XLSX from "xlsx";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";

const ImportFile = ({ show, handleClose, onSubmitImport }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileContent, setFileContent] = useState([]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            readFileContent(file);
        }
    };

    const readFileContent = (file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            setFileContent(jsonData);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleCloseModal = () => {
        setSelectedFile(null);
        setFileContent([]);
        handleClose();
    };

    const handleImport = () => {
        if (!selectedFile) {
            toast.warning("Please select a file first.");
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedFile);
        onSubmitImport(formData);
        handleCloseModal();
    };

    return (
        <>

            <div>
                <Modal show={show} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Import File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="card bg-light p-3 border-info lh-1">
                            <h3>Instructions for Importing a File:</h3>
                            <ul>
                                <li>Ensure your file is in <strong>Excel format</strong> (.xlsx, .xls, .csv).</li>
                                <li>The first row should contain <strong>column headers</strong>.</li>
                                <li>Ensure the file is <strong>UTF-8 encoded</strong> to prevent encoding issues.</li>
                                <li>If a column contains dates, format them as <strong>YYYY-MM-DD</strong> (e.g., 2024-09-05).</li>
                                <li>Some fields may have <span className="text-danger">unique validation</span>. If duplicates exist, they won’t be imported.</li>
                            </ul>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <input
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                onChange={handleFileChange}
                            />
                            <div className="ms-auto">
                                <Button
                                    variant="success"
                                    href="/assets/sample files/sample_product_import_file.xlsx"
                                    download
                                    className="btn-sm"
                                >
                                    <FaDownload style={{ marginRight: "5px" }} />
                                    Download Sample
                                </Button>
                            </div>
                        </div>
                        {fileContent.length > 0 && (
                            <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            {fileContent[0].map((col, index) => (
                                                <th key={index}>{col || `Column ${index + 1}`}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fileContent.slice(1).map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {row.map((cell, cellIndex) => (
                                                    <td key={cellIndex}>{cell || ""}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" size="sm" onClick={handleCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            size="sm"
                            onClick={handleImport}
                            disabled={!selectedFile}
                        >
                            Import
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
};

export default ImportFile;
